import { render, staticRenderFns } from "./restFacilitiesFixtures.vue?vue&type=template&id=0255fa89"
import script from "./restFacilitiesFixtures.vue?vue&type=script&lang=js"
export * from "./restFacilitiesFixtures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0255fa89')) {
      api.createRecord('0255fa89', component.options)
    } else {
      api.reload('0255fa89', component.options)
    }
    module.hot.accept("./restFacilitiesFixtures.vue?vue&type=template&id=0255fa89", function () {
      api.rerender('0255fa89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/rtf/restFacilitiesFixtures.vue"
export default component.exports